import * as React from "react"
import {SelectSeeker} from "@ui-seeker/core";

import {SETUP_COMPARISON} from "../../../@constants";
import {useRepricingFormData} from "../../@hooks";


const OPTIONS = [
	{ label: 'Higher', value: SETUP_COMPARISON.HIGHER },
	{ label: 'Lower', value: SETUP_COMPARISON.LOWER },
	{ label: 'Higher or Lower', value: SETUP_COMPARISON.HIGHER_OR_LOWER }
]

export default function RepricingFormSetUpSelect() {
	const { priceRule, handleChangeValue } = useRepricingFormData()

    return <SelectSeeker
		options={OPTIONS}
		value={priceRule}
		onChange={e => handleChangeValue('priceRule', e.target.value)}
	/>
}